import { hasValue, isNullOrUndefined } from '@r-and-a-shared-ui/utils';
import { useFormContext } from 'react-hook-form';
import { FormFieldPreviewProps } from '../FormFieldPreview/FormFieldPreview';
import styles from './FormDropdownsGroupPreview.module.scss';

export const FormDropdownsGroupPreview = (props: FormFieldPreviewProps) => {
  const { label, hideLabel, subfields } = props;
  const { watch } = useFormContext();

  return (
    <div className={styles.cell}>
      {!hideLabel && hasValue(label) && (
        <label className={styles.label}>{label}</label>
      )}
      <div className={styles.group}>
        {subfields?.map(field => {
          let val = watch(field.name);
          if (isNullOrUndefined(val) || !hasValue(val) || val === 0) {
            val = '-';
          }
          return (
            <div className={styles.item} key={field.name}>
              <div className={styles.label}>{field.label?.slice(0, 2)}</div>
              <div className={styles.value}>{val}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FormDropdownsGroupPreview;
